import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { UserData } from '../shared/models/user.model';

var accessToken: string;
var id_token: string;
var stateResponse: string;
var cryptObj = window.crypto;
var Sessionstore = sessionStorage.AppaccessToken == 'undefined' || sessionStorage.AppaccessToken == null;
@Injectable()
export class AuthHelper {
    constructor() {
        if (Sessionstore) {
            // this.getTokenResponse();
            sessionStorage.AppaccessToken = accessToken;
            sessionStorage.idToken = id_token;
            sessionStorage.respState = stateResponse;
        }
    }
    userData = new UserData();
    private getTokenResponse() {
        if (location.hash) {
            if (location.hash.split('access_token=')) {
                accessToken = location.hash.split('access_token=')[1].split('&')[0];
                id_token = location.hash.split('id_token=')[1].split('&')[0];
                stateResponse = location.hash.split('state=')[1].split('&')[0];
            }
        }
    }
    //Generates guid for nonce and state
    guid() {
        //An array of 8 16-bit unsigned integers
        var buf = new Uint16Array(8);
        cryptObj.getRandomValues(buf);
        function s4(num: number) {
            var ret = num.toString(16); //The number will show as an hexadecimal value
            while (ret.length < 4) {
                ret = '0' + ret;
            }
            return ret;
        }
        return s4(buf[0]) + s4(buf[1]) + '-' + s4(buf[2]) + '-' + s4(buf[3]) + '-' +
            s4(buf[4]) + '-' + s4(buf[5]) + s4(buf[6]) + s4(buf[7]);
    }
    login() {
        window.location.href = "https://login.microsoftonline.com/" + environment.AADconfig.tenant + "/oauth2/authorize?client_id=" + environment.AADconfig.clientId + "&response_type=token+id_token& resource=https://graph.microsoft.com & state=" + sessionStorage.state + "& nonce=" + sessionStorage.nonce + " & redirect_uri=" + environment.AADconfig.redirectUri;
    }

    setUserRoleAndLoginDetails(){ 
        this.userData = JSON.parse(localStorage.getItem("userprofile")!);
        if (this.userData == null || this.userData == undefined) {
            this.login();
        } else if(this.userData.Email != ''){
            if (this.userData.SecurityroleDescription == undefined && this.userData.SecurityroleDescription == null && this.userData.SecurityroleDescription == "") {
                this.login();
            }
        }
    }
}
